import _Vue from 'vue';
import { Store } from 'vuex';
import Router, { NavigationGuard } from 'vue-router';
import { vuexOidcCreateRouterMiddleware, vuexOidcCreateStoreModule } from 'vuex-oidc';
import HashLocalStorage from '../utils/HashLocalStorage';

export class OidcPluginOptions {
  public router!: Router;
  public oidcSettings!: any;
  public store!: Store<any>;
  public callbackRouter = '/callback';
  public storage!: any;
  public middleware?: NavigationGuard;
}

const clearStorage = () => window.localStorage.removeItem('vuex');

export default function OidcPlugin(Vue: typeof _Vue, options: OidcPluginOptions): void {
  const storage = options.storage || new HashLocalStorage();
  const oidcModule = vuexOidcCreateStoreModule(options.oidcSettings,
    {
      namespaced: true,
      dispatchEventsOnWindow: true
    },
    {
      userUnloaded: clearStorage,
      accessTokenExpired: clearStorage,
      userSignedOut: clearStorage,
    }
  );
  options.store.subscribe((mutation: any, state: any) => {
    if (mutation.type.indexOf('oidc/') > -1) {
      storage.setItem('oidc', state.oidc);
    }
  });
  options.store.registerModule('oidc', oidcModule);
  const stored = storage.getItem('oidc');
  if (stored) {
    options.store.replaceState(Object.assign({}, options.store.state, {
      oidc: stored
    }));
  }

  options.middleware = options.middleware || vuexOidcCreateRouterMiddleware(options.store, 'oidc');
  options.router.beforeEach(options.middleware as any);
  _Vue.component('logout-page', {
    render: (createElement: any) => createElement('div'),
    created() {
      options.store.commit('user/RESET');
      window.localStorage.removeItem('vuex');
      window.localStorage.removeItem('oidc');
      options.store.dispatch('oidc/signOutOidc');
    },
  });
}
